import * as React from 'react';

import type { TableStates } from './types';

/** Context in the document  */
export const TableStatesContext = React.createContext<TableStates>(new Map());
